<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon far fa-comment-dots"></i> Diga Aí <small>Formulário de Cadastro</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon far fa-comment-dots"></i> Diga Aí</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <form id="form1" class="form-horizontal">
                        <div class="card-body">
                            <div class="col-xs-12 col-sm-12 col-lg-6">
                                <h4>Dados do Diga Aí</h4>
                                <div class="form-group row">
                                    <label for="tipo_diga" class="col-sm-3 col-form-label">Tipo de Contato</label>
                                    <div class="col-sm-9">
                                        <select-editor v-model="entity.tipo_contato" data-placeholder="Escolha o Tipo de Contato">
                                            <option value="Dúvidas">Dúvidas</option>
                                            <option value="Sugestões">Sugestões</option>
                                            <option value="Participações">Participações</option>
                                            <option value="Elogios">Elogios</option>
                                            <option value="Outros">Outros</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="nome" class="col-sm-3 col-form-label">Nome</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="nome" name="nome" v-model="entity.nome" size="50" maxlength="150" placeholder="Nome" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-3 col-form-label">E-mail</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" id="email" name="email" v-model="entity.email" size="50" maxlength="150" placeholder="E-mail" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="telefone" class="col-sm-3 col-form-label">Telefone</label>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" id="telefone" name="telefone" v-model="entity.telefone" size="20" maxlength="20" placeholder="Telefone" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="empresa" class="col-sm-3 col-form-label">Empresa</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" id="empresa" name="empresa" v-model="entity.empresa" size="50" maxlength="150" placeholder="Empresa" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="mensagem" class="col-sm-3 col-form-label">Mensagem</label>
                                    <div class="col-sm-9">
                                        <textarea type="text" class="form-control validate[required]" v-model="entity.mensagem" rows="10" placeholder="Mensagem" />
                                    </div>
                                </div>
                                <div class="form-group row" v-if="entity.imagem">
                                    <label for="mensagem" class="col-sm-3 col-form-label">Imagem</label>
                                    <div class="col-sm-9">
                                        <img :src="entity.imagem" style="width: 100%;"/>
                                    </div>
                                </div>  
                                <div class="form-group row" v-if="entity.audio">
                                    <label for="mensagem" class="col-sm-3 col-form-label">Áudio</label>
                                    <div class="col-sm-9">
                                        <audio controls :src="entity.audio"/>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="entity.video">
                                    <label for="mensagem" class="col-sm-3 col-form-label">Vídeo</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="video" name="video" v-model="entity.video" size="20" maxlength="20" placeholder="Vídeo" />
                                    </div>
                                </div>
                                <h4>Resposta da Diga Aí</h4>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">Status</label>
                                    <div class="col-sm-6">
                                        <select-editor v-model="entity.status_diga" data-placeholder="Escolha o Status da Diga Aí">
                                            <option value="Recebido">Recebido</option>
                                            <option value="Em Andamento">Em Andamento</option>
                                            <option value="Concluído">Concluído</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="resposta" class="col-sm-3 col-form-label">Resposta</label>
                                    <div class="col-sm-9">
                                        <textarea type="text" class="form-control" v-model="entity.resposta" rows="10" placeholder="Resposta" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer">
                        <div class="offset-sm-1 col-sm-11">
                            <button type="button" v-if="this.$route.params.id == 0" v-on:click="insertEntity" class="btn btn-primary">Inserir</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="updateEntity" class="btn btn-info">Alterar</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="deleteEntity" class="btn btn-danger">Excluir</button>
                            <button type="button" v-on:click="back" class="btn btn-default">Voltar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    import DenunciaController from "@/controllers/diga.controller";

    export default {
        data: function () {
            return {
                entity: {
                    status_diga: "Recebido"
                }
            };
        },
        mounted() {
            this.$validator.validate("#form1");
            const id = parseInt(this.$route.params.id, 10);
            this.loadEntity(id);
            $(":input").inputmask();
        },
        methods: {
            loadEntity: function (id) {

                if (id === 0)
                    return;

                DenunciaController.getById(id)
                    .then(response => {
                        this.entity = response.data.result;
                    });
            },
            insertEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                DenunciaController.insert(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados cadastrados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            }
                        );
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            updateEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                DenunciaController.update(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados alterados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            });
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            deleteEntity: function (event) {
                event.target.disabled = true;

                let vm = this;

                vm.$dialogs.confirm({
                    title: 'Confirmar Exclusão!',
                    content: 'Deseja realmente excluir estes dados?',
                    icon: 'fa fa-exclamation-triangle ',
                    type: 'red',
                    buttons: {
                        confirm: {
                            text: 'Confirmar',
                            btnClass: 'btn-red',
                            action: function () {
                                event.target.disabled = true;

                                DenunciaController.delete(vm.entity)
                                    .then(response => {

                                        if (!response.data.success) {
                                            vm.$toastr.error(response.data.error, 'Erro!', {
                                                timeOut: 8000,
                                                onHidden: function () {
                                                    event.target.disabled = false;
                                                }
                                            });
                                            return;
                                        }

                                        vm.$toastr.success("Dados excluídos com sucesso.", "Aviso",
                                            {
                                                onHidden: function () {
                                                    vm.back();
                                                }
                                            }
                                        );
                                    })
                                    .catch(e => {
                                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                                        event.target.disabled = false;
                                    });
                            }
                        },
                        close: {
                            text: 'Cancelar'
                        }
                    }
                });
                event.target.disabled = false;
            },
            back: function () {
                this.$router.push({ name: "list-diga" });
            }
        }
    };
</script>

<style scoped>
</style>